import { toast } from '@approvalmax/ui/src/components';
import { useCallback, useState } from 'react';
import { amplitudeService } from 'services/amplitude';
import { useCompleteRegistration } from 'shared/data/webApp/v2';
import { useResendTimeout } from 'shared/hooks/useResendTimeout';

import {
    maxButtonClick,
    resendNowTimeoutStorageKey,
    resendTimeout,
    resendTomorrowTimeoutStorageKey,
} from './Content.constants';
import { messages } from './Content.messages';

export const useSendLinkButtons = (userId: string | undefined, signupType: string) => {
    const [sendNowClickCount, setSendNowClickCount] = useState(0);
    const [sendTomorrowClickCount, setSendTomorrowClickCount] = useState(0);

    const {
        startTimer: startTimerNow,
        isTimerActive: isTimerActiveNow,
        formattedResendTime: resendTimeNow,
    } = useResendTimeout(resendNowTimeoutStorageKey, resendTimeout);

    const {
        startTimer: startTimerTomorrow,
        isTimerActive: isTimerActiveTomorrow,
        formattedResendTime: resendTimeTomorrow,
    } = useResendTimeout(resendTomorrowTimeoutStorageKey, resendTimeout);

    const { mutateAsync: completeRegistration } = useCompleteRegistration();

    const handleSendNow = useCallback(async () => {
        startTimerNow();
        setSendNowClickCount((value) => value + 1);

        await completeRegistration({
            body: {
                isEmailSendingPostponed: false,
            },
        });

        toast.success(messages.toastSendNow, { position: 'top-center' });
        amplitudeService.sendData('signup: click on send link to email now (mobile screen)', {
            user_id: userId,
            signup_type: signupType,
        });
    }, [completeRegistration, signupType, startTimerNow, userId]);

    const handleSendTomorrow = useCallback(async () => {
        startTimerTomorrow();
        setSendTomorrowClickCount((value) => value + 1);

        await completeRegistration({
            body: {
                isEmailSendingPostponed: true,
            },
        });

        toast.success(messages.toastSendTomorrow, { position: 'top-center' });
        amplitudeService.sendData('signup: click on send link tomorrow (mobile screen)', {
            user_id: userId,
            signup_type: signupType,
        });
    }, [completeRegistration, signupType, startTimerTomorrow, userId]);

    return {
        isTimerActiveNow,
        resendTimeNow,
        handleSendNow,
        isSendNowDisabled: sendNowClickCount >= maxButtonClick,

        isTimerActiveTomorrow,
        resendTimeTomorrow,
        handleSendTomorrow,
        isSendTomorrowDisabled: sendTomorrowClickCount >= maxButtonClick,
    };
};
